import {
	Directive,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { FnGoogleLocationService } from './fn-google-location.service';
import { FnGoogleLocation } from './fn-google-location.model';
 import {} from 'google-maps';

@Directive({
	selector: '[fnGoogleLocation]',
})
export class FnGoogleLocationDirective implements OnInit {
	private gPlace: any;
	private internalOptions: any = {};
	private bounds: any;

	@Input() options: any;
	@Output() changeCB = new EventEmitter<FnGoogleLocation>();

	constructor(
		private el: ElementRef,
		private fnGooglePlaceSvcs: FnGoogleLocationService
	) {}

	private googlePlaceCodes(addressArray: any[]): object {
		const returnObj:any = {};
		addressArray.forEach((addrVal: any) => {
			addrVal.types.forEach((typeKey: string | number) => {
				returnObj[typeKey] = addrVal.short_name;
			});
		});
		return returnObj;
	}

	private getNodeValue(uniueKey: string, isClass: boolean = false): any {
		let domNode: any;
		if (isClass) {
			domNode = document.getElementsByClassName(uniueKey)[0];
		} else {
			domNode = document.getElementById(uniueKey);
		}

		// tslint:disable-next-line: triple-equals
		return domNode == undefined || domNode == null ? '' : domNode.innerText;
	}
	private readDeailFromPlaceObject(placeObj: any): void {
		// tslint:disable-next-line: triple-equals
		if (placeObj == null || placeObj == undefined) {
			// scope.callback({details: null});
		} else {
			const codeMap: any = this.googlePlaceCodes(placeObj.address_components);
			const geometry = placeObj.geometry;
			const googlePlaceDom = document.createElement('span');
			googlePlaceDom.innerHTML = placeObj.adr_address;

			if (document.getElementById('hidden-loc')) {
				document.getElementById('hidden-loc').remove();
			}

			const hiddenDiv = document.createElement('div');
			hiddenDiv.id = 'hidden-loc';
			hiddenDiv.style.display = 'none';
			const bodyTag = document.getElementsByTagName('body');
			hiddenDiv.appendChild(googlePlaceDom);
			bodyTag[0].appendChild(hiddenDiv);

			this.fnGooglePlaceSvcs
				.getTimezonDetail(geometry.location.lat(), geometry.location.lng())
				.subscribe((resp: any) => {
					// tslint:disable-next-line: no-shadowed-variable
					const locationDetail = new FnGoogleLocation();

					locationDetail.country = this.getNodeValue('country-name', true);

					locationDetail.city = this.getNodeValue('locality', true);

					locationDetail.region = this.getNodeValue('region', true);
					locationDetail.zipCode = this.getNodeValue('postal-code', true);
					locationDetail.siteName = placeObj.name;
					locationDetail.siteLongitude = geometry.location.lng();
					locationDetail.siteLatitude = geometry.location.lat();
					locationDetail.utcOffset = placeObj.utc_offset_minutes;
					locationDetail.addressLine1 = this.getNodeValue(
						'extended-address',
						true
					);
					locationDetail.addressLine2 = this.getNodeValue(
						'street-address',
						true
					);
					locationDetail.formatted_address = placeObj.formatted_address;
					locationDetail.countryCode = codeMap.country;
					locationDetail.geoAddrees =
						placeObj.name + ' ' + placeObj.formatted_address;
					locationDetail.geoPlaceId = placeObj.place_id;
					locationDetail.dstOffset = placeObj.dstOffset;
					locationDetail.timeZoneId = resp.zoneName;
					locationDetail.timeZoneName = resp.abbreviation;

					this.changeCB.emit(locationDetail);
				});
		}
	}

	private placeChangeSubscription(): void {
		google.maps.event.addListener(this.gPlace, 'place_changed', () => {
			const result = this.gPlace.getPlace();
			console.log(result);
			if (result !== undefined) {
				if (result.address_components !== undefined) {
					// this.el.nativeElement.value
					this.readDeailFromPlaceObject(result);
				} else {
					// TODO
				}
			}
		});
	}

	private loadDefaultOption(): void {
		this.internalOptions = {};
		if (this.options) {
			if (this.options.types) {
				this.internalOptions.types = [];
				this.internalOptions.types.push(this.options.types);
				this.gPlace.setTypes(this.internalOptions.types);
			} else {
				this.gPlace.setTypes([]);
			}

			if (this.options.bounds) {
				this.bounds = this.options.bounds;
				this.gPlace.setBounds(this.bounds);
			} else {
				this.gPlace.setBounds(null);
			}

			if (this.options.country) {
				this.internalOptions.componentRestrictions = {
					country: this.options.country,
				};
				this.gPlace.setComponentRestrictions(
					this.internalOptions.componentRestrictions
				);
			} else {
				this.gPlace.setComponentRestrictions(null);
			}
		}
	}

	ngOnInit(): void {
		this.loadDefaultOption();

		this.fnGooglePlaceSvcs.loadGoogleScript().subscribe(
			(isLoaded: boolean) => {
				this.gPlace = new google.maps.places.Autocomplete(
					this.el.nativeElement,
					{}
				);
				this.gPlace.setFields([
					'address_components',
					'formatted_address',
					'geometry',
					'name',
					'place_id',
					'utc_offset_minutes',
					'adr_address',
				]);
				this.placeChangeSubscription();

				// tslint:disable-next-line: new-parens
				// this.geocoder = new google.maps.Geocoder();
			},
			(error: any) => {
				// TODO
			}
		);
	}
}
